/**
 * AuthClientHook.ts
 * This hook used to obtain instance of Auth0Client in component from auth0-spa-js package
 */
import { Auth0Client } from "@auth0/auth0-spa-js";

export function useAuth0Client() {
  const domain = import.meta.env.VITE_AUTH0_DOMAIN;
  const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID;
  const audience = import.meta.env.VITE_AUTH0_AUDIENCE;

  if (!domain || !clientId || !audience) {
    throw new Error(
      "Missing Auth0 env settings\n" +
        `VITE_AUTH0_DOMAIN=${import.meta.env.VITE_AUTH0_DOMAIN}\n` +
        `VITE_AUTH0_CLIENT_ID=${import.meta.env.VITE_AUTH0_CLIENT_ID}\n` +
        `VITE_AUTH0_AUDIENCE=${import.meta.env.VITE_AUTH0_AUDIENCE}`,
    );
  }

  const auth0Client = new Auth0Client({
    domain,
    clientId: clientId,
    authorizationParams: {
      audience,
      scope: "openid profile email offline_access",
      redirect_uri: globalThis.window.location.pathname,
    },
    useRefreshTokens: true,
    cacheLocation: "localstorage",
  });

  return {
    auth0Client,
  };
}
